<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>分销订单</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                            ref="tableFrom"
                            :model="tableFrom"
                            :label-width="labelWidth"
                            :label-position="labelPosition"
                            @submit.native.prevent>
                        <Row type="flex" :gutter="24">
                            <Col v-bind="grid">
                                <FormItem label="分销商ID：" label-for="user_id">
                                    <Input size="default" enter-button placeholder="分销商ID" clearable v-model="tableFrom.user_id"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="分销商姓名：" label-for="order_no">
                                    <Input size="default" enter-button placeholder="分销商姓名" clearable v-model="tableFrom.real_name"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="分销商手机号：" label-for="mobile">
                                    <Input size="default" enter-button placeholder="分销商手机号" clearable v-model="tableFrom.mobile"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="订单编号：" label-for="order_no">
                                    <Input size="default" enter-button placeholder="订单编号" clearable v-model="tableFrom.order_no"/>
                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="结算状态：" label-for="type">
                                    <Select v-model="tableFrom.type"  element-id="type">
                                        <Option value="1">未结算</Option>
                                        <Option value="2">已结算</Option>
                                    </Select>

                                </FormItem>
                            </Col>
                            <Col v-bind="grid">
                                <FormItem label="下单时间：" label-for="create_time">
                                    <DatePicker
                                            :editable="false"
                                            @on-change="onchangeTime"
                                            :value="timeVal"
                                            format="yyyy/MM/dd"
                                            type="daterange"
                                            placement="bottom-start"
                                            placeholder="自定义时间"
                                            style="width: 300px"
                                            class="mr20"></DatePicker>
                                </FormItem>
                            </Col>
                            <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24" class="search">
                                <FormItem>
                                    <Button type="primary" icon="ios-search" @click="userSearchs">搜索</Button>
                                    <Button type="primary" style="margin-left: 20px" icon="ios-search" @click="excelOut">导出</Button>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" class="mb20">
                            <Col v-bind="grid">
                            </Col>
                        </Row>
                    </Form>
                    <Table
                            class="mt25"
                            :columns="columns1"
                            :data="tableList"
                            :loading="loading"
                            ref="selection"
                            highlight-row
                            no-userFrom-text="暂无数据"
                            no-filtered-userFrom-text="暂无筛选结果">
                        <template slot-scope="{ row, index }" slot="order_id">
                            <span v-text="row.order_master.order_sn" style="display: block"></span>
                        </template>
                        <template slot-scope="{ row, index }" slot="info">
                            <div class="tabBox dis-flex" v-for="(val, i) in row.order_master.goods" :key="i">
                                <div class="tabBox_img" v-viewer>
                                    <img v-lazy="val.pic_url"/>
                                </div>
                                <span class="tabBox_tit">
                                    {{ val.product_name + " | "}}
                                    <div class="goods-props clearfix" v-if="val.sku_name">
                                        {{val.sku_name}}
                                    </div>
                                </span>
                                <span class="tabBox_pice">
                                    {{"￥" + val.price + " x " + val.number}}
                                </span>
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="nick_name">
                            <a @click="showUserInfo(row)" v-if="row.user">{{ row.user.nick_name }}</a>
                        </template>
                        <template slot-scope="{ row, index }" slot="order_status">
                            <div>付款状态:{{ PayStatusEnum[row.order_master.pay_status].name }}</div>
                            <div>发货状态:{{ DeliveryStatusEnum[row.order_master.delivery_status].name }}</div>
                            <div>收货状态:{{ ReceiptStatusEnum[row.order_master.receipt_status].name }}</div>
                            <div>订单状态:{{ row.order_master.state_text }}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="money">
                            <div v-if="row.first_user_id">一级分销商：{{row.dealer_first.user.nick_name}}(ID:{{row.dealer_first.user.id}}) <span class="ml10">分销佣金：</span>{{row.first_money}}</div>
                            <div v-if="row.second_user_id">二级分销商：{{row.dealer_second.user.nick_name}}(ID:{{row.dealer_second.user.id}}) <span class="ml10">分销佣金：</span>{{row.second_money}}</div>
                            <div v-if="row.third_user_id">三级分销商：{{row.dealer_third.user.nick_name}}(ID:{{row.dealer_third.user.id}}) <span class="ml10">分销佣金：</span>{{row.third_money}}</div>
                        </template>
                        <template slot-scope="{ row, index }" slot="settle_status">
                            <Tag color="primary" v-if="row.is_settled == 1">已结算</Tag>
                            <Tag v-else>未结算</Tag>
                        </template>
                    </Table>
                    <div class="acea-row row-right page">
                        <Page
                                :total="total"
                                :current="tableFrom.page"
                                show-elevator
                                show-total
                                @on-change="pageChange"
                                :page-size="tableFrom.limit"/>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "../second.vue";
    import {
        OrderStatusEnum,
        PayStatusEnum,
        DeliveryStatusEnum,
        ReceiptStatusEnum
    } from '@/common/enum/order'

    export default {
        name: "index",
        components: { second },
        data() {
            return {
                OrderStatusEnum,
                DeliveryStatusEnum,
                PayStatusEnum,
                ReceiptStatusEnum,
                isLoad: false,
                headeNum: [
                    { type: "0", name: "全部" },
                    { type: "1", name: "未结算" },
                    { type: "2", name: "已结算" },
                ],
                loading: false,
                columns1: [
                    {
                        title: "订单号",
                        align: "center",
                        slot: "order_id",
                        minWidth: 130,
                    },
                    {
                        title: "商品信息",
                        slot: "info",
                        minWidth: 300,
                    },
                    {
                        title: "用户信息",
                        slot: "nick_name",
                        minWidth: 80,
                    },
                    {
                        title: "佣金明细",
                        slot: "money",
                        minWidth: 250,
                    },
                    {
                        title: "订单状态",
                        slot: "order_status",
                        align: "center",
                        minWidth: 130,
                    },
                    {
                        title: "结算状态",
                        slot: "settle_status",
                        align: "center",
                        minWidth: 130,
                    },
                ],
                tableList: [],
                grid: {
                    xl: 7,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                timeVal: [],
                tableFrom: {
                    user_id: this.$route.query.user_id ? this.$route.query.user_id : '',
                    type: "",
                    search: "",
                    export: 0,
                    page: 1,
                    limit: 15,
                },
                tableFrom2: {
                    status: "",
                    store_name: "",
                    export: 1,
                },
                total: 0,
            };
        },
        computed: {
            labelWidth() {
                return 80;
            },
            labelPosition() {
                return 'left';
            },
        },
        created() {
            this.getList();
        },
        methods: {
            // 数据导出；
            async exports() {

            },
            // 具体日期
            onchangeTime(e) {
                this.timeVal = e;
                this.tableFrom.create_time = this.timeVal.join("-");
            },
            getExcelData(excelData) {
                return new Promise((resolve, reject) => {
                    stroeBargainApi(excelData).then((res) => {
                        return resolve(res.data);
                    });
                });
            },
            onClickTab(type) {
                this.tableFrom.page = 1;
                this.tableFrom.type = type;
                this.getList();
            },

            // 列表
            getList() {
                this.loading = true;
                this.axios.post('/store/app.dealer.order/list', this.tableFrom)
                    .then(async (res) => {
                        let data = res.data;
                        this.tableList = data.list.data;
                        this.total = data.list.total;
                        this.loading = false;
                    })
                    .catch((res) => {
                        this.loading = false;
                        this.$Message.error(res.msg);
                    });
            },
            pageChange(index) {
                this.tableFrom.page = index;
                this.getList();
            },
            // 表格搜索
            userSearchs() {
                this.tableFrom.page = 1;
                this.getList();
            },
            // 导出
            excelOut() {
                if (this.isLoad) {
                    return false
                }

                this.isLoad = !this.isLoad
                setTimeout(function () {
                    this.isLoad = false
                }.bind(this), 100000);
                this.axios.post('/store/app.dealer.order/export', this.filter)
                    .then(res => {
                        this.isLoad = false
                        if (res.code == 1) {
                            import('@/vendor/Export2Excel.js').then(excel => {
                                var expCellName = res.data.expCellName
                                var tHeader = []
                                var filterVal = []
                                for (var i in expCellName) {
                                    tHeader.push(expCellName[i])
                                    filterVal.push(i)
                                }
                                const expTableData = res.data.expTableData
                                const data = this.formatJson(filterVal, expTableData)
                                var d = new Date()
                                var year = d.getFullYear()
                                var month = d.getMonth()
                                var date = d.getDate()
                                var hour = d.getHours()
                                var minute = d.getMinutes()
                                var second = d.getSeconds()
                                month = month < 10 ? '0' + month : month
                                date = date < 10 ? '0' + date : date
                                hour = hour < 10 ? '0' + hour : hour
                                minute = minute < 10 ? '0' + minute : minute
                                second = second < 10 ? '0' + second : second
                                excel.export_json_to_excel({
                                    header: tHeader,
                                    data,
                                    filename: '分销订单导出_' + year + '' + month + '' + date + '' + hour + '' + minute + '' + second,
                                    autoWidth: this.autoWidth,
                                    bookType: this.bookType
                                })
                            })
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 3 * 1000
                            })
                        }
                    })
            },
            formatJson (filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                    return v[j]
                }))
            },
        },
    }
</script>

<style scoped lang="less">
    .tabBox {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;

        .tabBox_img {
            width: 36px;
            height: 36px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .tabBox_tit {
            width: 60%;
            font-size: 12px !important;
            margin: 0 2px 0 10px;
            letter-spacing: 1px;
            padding: 5px 0;
            box-sizing: border-box;
        }
    }
</style>
